import type { FC, ReactNode } from 'react'
import type { SiteImage } from '@/types/content'

import Image from 'next/image'
import { useRef } from 'react'
import { cn } from '@/lib/utils'
import { useScrollProgress } from '@/lib/use-scroll-progress'

import { labelFor } from '@/components/site/photo'

interface ParallaxPhotoProps {
    image: SiteImage
    className?: string
    sizes?: string
    showLabel?: boolean
}

// A photo whose picture drifts gently against its frame as the page scrolls.
const ParallaxPhoto: FC<ParallaxPhotoProps> = ({ image, className, sizes = '(min-width: 1024px) 50vw, 100vw', showLabel = true }): ReactNode => {
    const ref = useRef<HTMLElement>(null)

    useScrollProgress(ref, 'through')

    return (
        <figure ref={ref} className={cn('relative overflow-hidden rounded-[2rem] bg-muted', className)}>
            <div className='parallax-media absolute inset-0'>
                <Image src={image.src} alt={image.alt} fill sizes={sizes} className='object-cover' />
            </div>

            {showLabel && (
                <figcaption className='absolute bottom-3 left-3 rounded-md bg-navy-deep/85 px-2.5 py-1 text-sm font-semibold text-white'>
                    {labelFor(image)}
                </figcaption>
            )}
        </figure>
    )
}

export default ParallaxPhoto
